export default class Modal {
    constructor($modal) {
        this.$modal = $modal;
        this.$content = $modal.querySelector('[data-modal-content]');
        this.id = $modal.dataset.modal;
        this.$triggers = document.querySelectorAll(`[data-open-modal="${this.id}"]`);
        this.$closeTriggers = this.$modal.querySelectorAll('[data-close-modal]');
        this.shouldModifyUrl = this.$modal.dataset.modalOnload === undefined;

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.isActive = this.isActive.bind(this);
        this.documentClicked = this.documentClicked.bind(this);
        this.modalOpenedInDocument = this.modalOpenedInDocument.bind(this);
        this.modalOpenEventTriggered = this.modalOpenEventTriggered.bind(this);
        this.checkUrl = this.checkUrl.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);

        this.$triggers.forEach( $trigger => $trigger.addEventListener('click', this.openModal));
        this.$closeTriggers.forEach( $trigger => $trigger.addEventListener('click', this.closeModal));

        // Escape
        document.addEventListener('keydown', this.handleKeydown);
        // click outside
        document.addEventListener('click', this.documentClicked);
        // if another modal opens we close this one
        document.addEventListener('modal-opened', this.modalOpenedInDocument);
        // a modal open event was triggered
        document.addEventListener('open-modal', this.modalOpenEventTriggered);

        this.checkUrl();
    }

    checkUrl() {
        if(window.location.hash === '#' + this.id) {
            this.openModal();
        }
    }

    isActive() {
        return this.$modal.classList.contains('modal--visible');
    }

    openModal(e) {
        if(e) {
            e.preventDefault();
        }

        // notify body about opening a modal;
        var event = new CustomEvent("modal-opened", {'detail': {
            id: this.id,
        }});
        document.dispatchEvent(event);

        if (this.$modal.querySelectorAll('#youtube-player[src*="youtube"]').length > 0 && player && typeof player.playVideo === "function") {
            player.playVideo();
        }

        this.$modal.classList.add('modal--visible');

        // only add the modal id in the url if this is not a on load modal
        if (this.shouldModifyUrl) {
            // set the modal id in the url
            window.location.hash = this.id;
        }
    }

    closeModal(e) {
        if (e) {
            e.preventDefault();
        }
        this.$modal.classList.remove('modal--visible');


        if (this.$modal.querySelectorAll('#youtube-player[src*="youtube"]').length > 0 && player && typeof player.playVideo === "function") {
            player.stopVideo();
        }

        history.pushState({}, '', placeholders.router.request);
    }

    modalOpenEventTriggered(e) {
        if(e.detail.id === this.id) {
            this.openModal(e);
        }
    }

    modalOpenedInDocument(e) {
        if(e.detail.id !== this.id && this.isActive()) {
            this.closeModal(e);
        }
    }

    documentClicked(e) {
        // prevent scripts close the modal password
        if(e.target.type === 'password') {
            return false;
        }

        // if we click on a trigger we open the modal and stop here
        if(e.target.closest(`[data-open-modal="${this.id}"]`) !== null) {
            this.openModal(e);
            return;
        }

        const isClickInside = this.$content.contains(e.target);
        let isTrigger = false;

        for(const $trigger of this.$triggers.values()) {
            if($trigger == e.target || $trigger.contains(e.target)){
                isTrigger = true;
            }
        }

        if (!isClickInside && !isTrigger && this.$modal.classList.contains('modal--overlay') && this.isActive()) {
            this.closeModal(e);
        }
    }

    handleKeydown(e) {
        if (e.key === 'Escape' && this.isActive()) {
            this.closeModal(e);
        }
    }
}